import { reactWidget } from 'reactR'

import Reactable from './Reactable.v2'

reactWidget('reactable', 'output', {
  Reactable
})

export * from './Reactable.v2'
